module.exports = __webpack_public_path__ + "img/image-sign-finish.9ba4d12d.png";